export default __webpack_public_path__ + "media/images/quotation-f626875c20a87f5a024099443e19a171.svg";